import * as ControlledProducts from './ControlledProducts'
import * as Inventory from './Inventory'
import * as ProductMap from './ProductMap'
import Home from './Home'
import IncompatibilityAnalysis from './IncompatibilityAnalysis'
import Login from './Login'
import RecoverPassword from './Login/RecoverPassword'
import LoginError from './LoginError'
import NotFound from './NotFound'
import NotPermission from './NotPermission'
import Overview from './Overview'
import CabinetProducts from './CabinetProducts'
import ControllerFispq from './ControllerFispq'
import News from './News'

export {
  ControlledProducts,
  Inventory,
  Home,
  NotFound,
  NotPermission,
  ProductMap,
  IncompatibilityAnalysis,
  Overview,
  Login,
  LoginError,
  RecoverPassword,
  CabinetProducts,
  ControllerFispq,
  News
}



// WEBPACK FOOTER //
// ./src/containers/index.js